<template>
	<div class="rectangle-box">
		<div v-if="visibleBorders.left" class="rectangle-box--left">
			<svg class="lines--top-left">
				<polygon class="st2" points="1 1 0 0 0 2 1 2 1 1" />
				<polygon class="st1" points="1 1 1 2 2 2 1 1" />
				<polygon class="st2" points="2 1 2 0 0 0 1 1 2 1" />
				<polygon class="st1" points="2 1 1 1 2 2 2 1" />
			</svg>
			<svg class="lines--left">
				<rect class="st2" x="0" y="0" width="1" height="100%" />
				<rect class="st1" x="1" y="0" width="1" height="100%" />
			</svg>
			<svg class="lines--bottom-left">
				<polygon class="st2" points="1 0 0 0 0 2 1 1 1 0" />
				<polygon class="st1" points="1 0 1 1 2 0 1 0" />
				<polygon class="st1" points="1 1 0 2 2 2 2 1 1 1" />
				<polygon class="st2" points="1 1 2 1 2 0 1 1" />
			</svg>
		</div>
		<div class="rectangle-box--center">
			<svg v-if="visibleBorders.top" class="lines--top">
				<rect class="st2" x="0" y="0" width="100%" height="1" />
				<rect class="st1" x="0" y="1" width="100%" height="1" />
			</svg>
			<svg v-if="visibleBorders.bottom" class="lines--bottom">
				<rect class="st2" x="0" y="0" width="100%" height="1" />
				<rect class="st1" x="0" y="1" width="100%" height="1" />
			</svg>
		</div>
		<div v-if="visibleBorders.right" class="rectangle-box--right">
			<svg class="lines--top-right">
				<polygon class="st1" points="1 1 1 2 2 2 2 0 1 1" />
				<polygon class="st2" points="1 1 2 0 0 0 0 1 1 1" />
				<polygon class="st1" points="0 2 1 1 0 1 0 2" />
				<polygon class="st2" points="1 2 0 2 1 1 1 2" />
			</svg>
			<svg class="lines--right">
				<rect class="st2" x="0" y="0" width="1" height="100%" />
				<rect class="st1" x="1" y="0" width="1" height="100%" />
			</svg>
			<svg class="lines--bottom-right">
				<polygon class="st1" points="0 1 0 2 2 2 1 1 0 1"></polygon>
				<polygon class="st2" points="1 1 1 0 0 0 1 1" />
				<polygon class="st2" points="0 1 1 1 0 0 0 1"></polygon>
				<polygon class="st1" points="1 1 2 2 2 0 1 0 1 1"></polygon>
			</svg>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { Tuple } from "@/types";
import { computed } from "vue";

interface Props {
	border?: Tuple<number, 4> | null;
}

const { border = null } = defineProps<Props>();

type Border = {
	top: boolean;
	right: boolean;
	bottom: boolean;
	left: boolean;
};

const visibleBorders = computed((): Border => {
	if (border === null) {
		return { top: true, right: true, bottom: true, left: true };
	}
	return {
		top: border[0] === 1,
		right: border[1] === 1,
		bottom: border[2] === 1,
		left: border[3] === 1,
	};
});
</script>

<style lang="scss">
.rectangle-box {
	position: relative;
	width: 100%;
	height: 100%;
	@include flex-row-stretch;

	&--left,
	&--center,
	&--right {
		display: flex;
		position: relative;
		width: 100%;
	}

	&--left,
	&--right {
		@include flex-col-center;
		width: 2px;
	}

	&--center {
		@include flex-col-center;
		justify-content: space-between;
	}

	.lines {
		&--top,
		&--bottom {
			width: 100%;
			height: 2px;
		}

		&--top-left,
		&--bottom-left,
		&--top-right,
		&--bottom-right {
			width: 2px;
			height: 2px;
		}

		&--left,
		&--right {
			width: 2px;
			height: calc(100% - 4px);
		}
	}
}

.st0 {
	fill: none;
}

.st1 {
	fill: #63451a;
}

.st2 {
	fill: #edd091;
}
</style>
